import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CanonicalService {
	constructor(private meta: Meta, private router: Router) {
		this.router.events
			.pipe(filter((event) => event instanceof NavigationEnd))
			.subscribe((event: NavigationEnd) => {
				this.setCanonicalUrl(
					window.location.origin + event.urlAfterRedirects
				);
			});
	}

	setCanonicalUrl(url: string) {
		let link: HTMLLinkElement =
			document.querySelector("link[rel='canonical']") ||
			document.createElement('link');
		link.setAttribute('rel', 'canonical');
		link.setAttribute('href', url);
		if (!link.parentNode) {
			document.head.appendChild(link);
		}
		this.meta.updateTag({ rel: 'canonical', href: url });
	}
}
